import { ClockState } from '../../../core/models/enum';
import { PeriodCount } from '../../../helpers/matchTiming';
import { CreateEventCommand, EventPeriodEnum, EventVm } from '../../../utils/api';
import MatchClock from './MatchClock';
import { OvertimeUiMode } from './periodLabels';
import { ClockSnapshot } from '../live-clock/liveClock';

interface OwnProps {
    liveEnabled?: boolean;
    liveSnapshot?: ClockSnapshot;
    timeLocked?: boolean;
    draftTimeVerified?: boolean;
    event: EventVm | CreateEventCommand | null;
    clockState: ClockState;
    eventPeriod: EventPeriodEnum;
    eventTime: number;
    overtimeUiMode: OvertimeUiMode;
    isEventValid: boolean;
    periodCount: PeriodCount;
    startClock: () => void;
    pauseClock: () => void;
    stopClock: () => void;
    resetClock: () => void;
    setPeriod: (period: EventPeriodEnum, overtimeMode?: OvertimeUiMode) => void;
    modifyClock: (amount: number) => void;
    saveEvent: () => void;
}

export type Props = OwnProps;

export default MatchClock;
